/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootRoutes {
  ALTERAR_SENHA_ROUTE = '/login/alterar-senha',
  ALTERAR_SENHA_USERNAME_ROUTE = '/login/renovar-senha/:username',
  CONF_USUARIO_NOVA_SENHA_ROUTE = '/confirmar-usuario/:hash/nova-senha',
  CONFIRMAR_USUARIO_FALHA_ROUTE = '/falha-confirmar-usuario',
  CONFIRMAR_USUARIO_ROUTE = '/confirmar-usuario/:hash',
  FORGOT_PASSWORD_ROUTE = '/login/redefinir-senha',
  INACTIVITY_ROUTE = '/inatividade',
  LOGIN_ROUTE = '/login',
  NEW_PASSWORD_ROUTE = '/nova-senha/:hash',
  REDIRECT_ROUTE = '/estipulante',
  STIPULATOR_ROUTE = '/estipulante/:nrSeqGrupoContratoWeb/contrato/:nrSeqContrato',
}
export { RootRoutes };
